import { all, call, put, takeEvery } from 'redux-saga/effects'
import { notification } from 'services'
import MedicalGroupActions, {
  addMedicalGroupApi,
  getMedicalGroupDetailsApi,
  getMedicalGroupClinisApi,
  getMedicalGroupsApi,
  medicalGroupSetState,
  updateMedicalGroupApi,
  assignFacilitiesToMedicalGroupApi,
} from './actions'

export function* GET_MEDICAL_GROUPS({ payload }) {
  yield put(medicalGroupSetState({ loading: true, listing: [] }))
  const { res } = yield call(getMedicalGroupsApi, payload)
  if (res) {
    yield put(medicalGroupSetState({ loading: false, listing: res.data }))
    return
  }
  yield put(medicalGroupSetState({ loading: false, listing: [] }))
}

export function* GET_MEDICAL_GROUP_CLINICS({ payload }) {
  yield put(medicalGroupSetState({ groupClinicsLoading: true, groupClinics: [] }))
  const { res } = yield call(getMedicalGroupClinisApi, payload)
  if (res) {
    yield put(medicalGroupSetState({ groupClinicsLoading: false, groupClinics: res }))
    return
  }
  yield put(medicalGroupSetState({ groupClinicsLoading: false, groupClinics: [] }))
}

export function* GET_MEDICAL_GROUP_DETAILS({ payload }) {
  yield put(
    medicalGroupSetState({
      detailsLoading: true,
      details: null,
    }),
  )
  const { res } = yield call(getMedicalGroupDetailsApi, payload)
  if (res) {
    yield put(medicalGroupSetState({ detailsLoading: false, details: res.data }))
  }

  yield put(medicalGroupSetState({ detailsLoading: false }))
}

export function* ADD_MEDICAL_GROUP({ payload }) {
  yield put(
    medicalGroupSetState({
      addMedicalGroupStatus: 'loading',
    }),
  )
  const { res } = yield call(addMedicalGroupApi, payload)
  if (res) {
    yield put(
      medicalGroupSetState({
        addMedicalGroupStatus: 'success',
      }),
    )
    notification.success('Success', 'Medical group added!')
  }
  yield put(medicalGroupSetState({ addMedicalGroupStatus: null }))
}

export function* UPDATE_MEDICAL_GROUP({ payload }) {
  yield put(
    medicalGroupSetState({
      updateMedicalGroupStatus: 'loading',
    }),
  )
  const { res } = yield call(updateMedicalGroupApi, payload)
  if (res) {
    yield put(
      medicalGroupSetState({
        updateMedicalGroupStatus: 'success',
      }),
    )
    notification.success('Success', 'Medical group updated!')
  }
  yield put(medicalGroupSetState({ updateMedicalGroupStatus: null }))
}

export function* ASSIGN_FACILITIES({ payload }) {
  yield put(
    medicalGroupSetState({
      assignFacilitiesToGroupStatus: 'loading',
      detailsLoading: true,
    }),
  )
  const { res } = yield call(assignFacilitiesToMedicalGroupApi, payload)
  if (res) {
    yield put(
      medicalGroupSetState({
        assignFacilitiesToGroupStatus: 'success',
        detailsLoading: false,
        details: null,
      }),
    )
    notification.success('Success', 'Facilities assigned!')
  }
  yield put(
    medicalGroupSetState({
      assignFacilitiesToGroupStatus: null,
      detailsLoading: false,
      details: null,
    }),
  )
}

export default function* rootSaga() {
  yield all([
    takeEvery(MedicalGroupActions.GET_MEDICAL_GROUPS, GET_MEDICAL_GROUPS),
    takeEvery(MedicalGroupActions.GET_MEDICAL_GROUP_DETAILS, GET_MEDICAL_GROUP_DETAILS),
    takeEvery(MedicalGroupActions.GET_MEDICAL_GROUP_CLINICS, GET_MEDICAL_GROUP_CLINICS),
    takeEvery(MedicalGroupActions.ADD_MEDICAL_GROUP, ADD_MEDICAL_GROUP),
    takeEvery(MedicalGroupActions.UPDATE_MEDICAL_GROUP, UPDATE_MEDICAL_GROUP),
    takeEvery(MedicalGroupActions.ASSIGN_FACILITIES, ASSIGN_FACILITIES),
  ])
}
